import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["testid"]
const _hoisted_2 = { class: "info-modal__title" }
const _hoisted_3 = {
  key: 1,
  class: "info-modal__message"
}

import { type PropType } from 'vue';

import { type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoModal',
  props: {
  actionSecondary: { type: String, required: false },
  actionSecondaryTestId: { type: String, default: 'info-modal-action-secondary' },
  actionTertiary: { type: String, required: false },
  actionTertiaryTestId: { type: String, default: 'info-modal-action-tertiary' },
  action: { type: String, required: true },
  actionDisabled: { type: Boolean, default: false },
  actionTestId: { type: String, default: 'info-modal-action' },
  contentTestId: { type: String, default: 'info-modal-content' },
  message: { type: String, required: false },
  title: { type: String, required: true },
  variant: { type: String as PropType<ModalVariant>, default: 'light' },
  iconName: { type: String as PropType<'tick-circle-bulk' | 'refresh-2' | 'close-circle-bulk'>, default: 'tick-circle-bulk' },
  noIcon: { type: Boolean, default: false },
  wide: { type: Boolean, default: false },
  isError: { type: Boolean, default: false },
},
  emits: ["action-clicked", "action-secondary-clicked", "action-tertiary-clicked"],
  setup(__props, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "info-modal",
    "footer-variant": "centered",
    "can-close": false,
    wide: __props.wide,
    variant: __props.variant
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", {
        class: "info-modal__content",
        testid: __props.contentTestId
      }, [
        (!__props.noIcon)
          ? (_openBlock(), _createBlock(_component_ot_icon, {
              key: 0,
              class: _normalizeClass(["info-modal__status-icon", { 'info-modal__status-icon--error': __props.isError }]),
              name: __props.iconName
            }, null, 8, ["class", "name"]))
          : _createCommentVNode("", true),
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t(__props.title)), 1),
        (__props.message)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t(__props.message)), 1))
          : _renderSlot(_ctx.$slots, "content", { key: 2 })
      ], 8, _hoisted_1)
    ]),
    buttons: _withCtx(({ itemClass }) => [
      (__props.actionSecondary)
        ? (_openBlock(), _createBlock(_component_x_button, {
            key: 0,
            class: _normalizeClass(["info-modal__action info-modal__action--secondary", itemClass]),
            variant: "dark-outline",
            testid: __props.actionSecondaryTestId,
            text: _ctx.$t(__props.actionSecondary),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('action-secondary-clicked')))
          }, null, 8, ["testid", "text", "class"]))
        : _createCommentVNode("", true),
      (__props.actionTertiary)
        ? (_openBlock(), _createBlock(_component_x_button, {
            key: 1,
            class: _normalizeClass(["info-modal__action info-modal__action--tertiary", itemClass]),
            variant: "dark-outline",
            testid: __props.actionTertiaryTestId,
            text: _ctx.$t(__props.actionTertiary),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('action-tertiary-clicked')))
          }, null, 8, ["testid", "text", "class"]))
        : _createCommentVNode("", true),
      (__props.action)
        ? (_openBlock(), _createBlock(_component_x_button, {
            key: 2,
            class: _normalizeClass(["info-modal__action", itemClass]),
            variant: "primary",
            testid: __props.actionTestId,
            text: _ctx.$t(__props.action),
            disabled: __props.actionDisabled,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('action-clicked')))
          }, null, 8, ["testid", "text", "class", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["wide", "variant"]))
}
}

})